<div class="container">
  <div class="loading-overlay" *ngIf="loading">
    <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
  </div>

  <form class="card-form" [formGroup]="dpForm" autocomplete="off" novalidate>
    <div class="blue-top">
      <img class="blue-top-logo" src="app/assets/icea-logo.png" alt="ICEA LION" />
      <span class="blue-top-title">Home Insurance Details</span>
    </div>

    <div class="card-section top-section">
      <h2>Select Items</h2>
      <p class="section-hint">Please select the items you would like to insure and enter the amount</p>

      <!-- Building -->
      <div class="category-card" [class.category-active]="buildingEnabled">
        <div class="category-header" (click)="toggle('buildingEnabled')">
          <div class="toggle-circle" [class.active]="buildingEnabled">
            <span class="check-mark" *ngIf="buildingEnabled">✓</span>
          </div>
          <span class="category-name">Building</span>
          <span class="category-amount">KES {{buildingDisplayTotal}}</span>
        </div>

        <div class="category-body" *ngIf="buildingEnabled">
          <p class="hint-text">This is ONLY for owners and the amount should not include the land</p>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">Type of house</mat-label>
            <mat-select formControlName="buildingType" panelClass="form-select-popup">
              <mat-option class="form-option" [value]="opt" *ngFor="let opt of typeOfHouseOptions">
                {{opt}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">Building value (KES)</mat-label>
            <input matInput formControlName="buildingAmount" inputmode="numeric">
          </mat-form-field>
        </div>
      </div>

      <!-- Contents -->
      <div class="category-card" [class.category-active]="contentsEnabled">
        <div class="category-header" (click)="toggle('contentsEnabled')">
          <div class="toggle-circle" [class.active]="contentsEnabled">
            <span class="check-mark" *ngIf="contentsEnabled">✓</span>
          </div>
          <span class="category-name">Contents</span>
          <span class="category-amount">KES {{contentsDisplayTotal}}</span>
        </div>

        <div class="category-body" *ngIf="contentsEnabled">
          <div class="content-row">
            <span class="sub-label">Electronics</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="electronics" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">Mobile Phone(s)</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="mobilePhones" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">Laptops / Computers, printers, tablets</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="laptops" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">House furnishings</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="houseFurnishings" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">Kitchen Appliances</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="kitchenAppliances" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">CCTV, Solar inverters, Pumps, generators</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="cctvSolar" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">Clothing</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="clothing" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
          <div class="content-row">
            <span class="sub-label">Others</span>
            <mat-form-field appearance="outline" class="sub-amount-field">
              <input matInput formControlName="othersContents" inputmode="numeric" placeholder="Enter Amount">
            </mat-form-field>
          </div>
        </div>
      </div>

      <!-- House Staff -->
      <div class="category-card" [class.category-active]="staffEnabled">
        <div class="category-header" (click)="toggle('staffEnabled')">
          <div class="toggle-circle" [class.active]="staffEnabled">
            <span class="check-mark" *ngIf="staffEnabled">✓</span>
          </div>
          <span class="category-name">House Staff</span>
          <span class="category-amount">{{staffDisplayTotal}} staff</span>
        </div>

        <div class="category-body" *ngIf="staffEnabled">
          <div class="staff-row">
            <span class="sub-label">Househelp / Nanny / Cook</span>
            <div class="stepper-controls">
              <button mat-stroked-button type="button" class="stepper-btn" (click)="decrement('staffHousehelp')">−</button>
              <span class="stepper-value">{{dpForm.get('staffHousehelp')?.value}}</span>
              <button mat-stroked-button type="button" class="stepper-btn" (click)="increment('staffHousehelp')">+</button>
            </div>
          </div>
          <div class="staff-row">
            <span class="sub-label">Driver</span>
            <div class="stepper-controls">
              <button mat-stroked-button type="button" class="stepper-btn" (click)="decrement('staffDriver')">−</button>
              <span class="stepper-value">{{dpForm.get('staffDriver')?.value}}</span>
              <button mat-stroked-button type="button" class="stepper-btn" (click)="increment('staffDriver')">+</button>
            </div>
          </div>
          <div class="staff-row">
            <span class="sub-label">Caretaker</span>
            <div class="stepper-controls">
              <button mat-stroked-button type="button" class="stepper-btn" (click)="decrement('staffCaretaker')">−</button>
              <span class="stepper-value">{{dpForm.get('staffCaretaker')?.value}}</span>
              <button mat-stroked-button type="button" class="stepper-btn" (click)="increment('staffCaretaker')">+</button>
            </div>
          </div>
          <div class="staff-row">
            <span class="sub-label">Gardener</span>
            <div class="stepper-controls">
              <button mat-stroked-button type="button" class="stepper-btn" (click)="decrement('staffGardener')">−</button>
              <span class="stepper-value">{{dpForm.get('staffGardener')?.value}}</span>
              <button mat-stroked-button type="button" class="stepper-btn" (click)="increment('staffGardener')">+</button>
            </div>
          </div>
          <div class="staff-row">
            <span class="sub-label">Watchman</span>
            <div class="stepper-controls">
              <button mat-stroked-button type="button" class="stepper-btn" (click)="decrement('staffWatchman')">−</button>
              <span class="stepper-value">{{dpForm.get('staffWatchman')?.value}}</span>
              <button mat-stroked-button type="button" class="stepper-btn" (click)="increment('staffWatchman')">+</button>
            </div>
          </div>
        </div>
      </div>

      <!-- Liability -->
      <div class="category-card" [class.category-active]="liabilityEnabled" [class.category-disabled]="!buildingEnabled">
        <div class="category-header" (click)="buildingEnabled && toggle('liabilityEnabled')" [class.header-disabled]="!buildingEnabled">
          <div class="toggle-circle" [class.active]="liabilityEnabled">
            <span class="check-mark" *ngIf="liabilityEnabled">✓</span>
          </div>
          <span class="category-name">Liability</span>
          <span class="category-hint" *ngIf="!buildingEnabled">(requires Building)</span>
          <span class="category-amount" *ngIf="buildingEnabled">KES {{liabilityDisplayTotal}}</span>
        </div>

        <div class="category-body" *ngIf="liabilityEnabled">
          <mat-form-field appearance="outline" class="form-select" style="margin-top: 12px;">
            <mat-label class="form-select-placeholder-unselected">Liability Insurance</mat-label>
            <mat-select formControlName="liabilityType" panelClass="form-select-popup">
              <mat-option class="form-option" [value]="opt" *ngFor="let opt of liabilityTypeOptions">
                {{opt}}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="liability-description" *ngIf="dpForm.get('liabilityType')?.value === 'Owner'">
            <p>Owner's Liability Cover protects you as the homeowner if a third party suffers injury, death, or property damage while on your property and you are found legally liable.</p>
          </div>

          <div class="liability-description" *ngIf="dpForm.get('liabilityType')?.value === 'Occupier'">
            <p>Occupiers' Liability Cover protects you if someone is injured or their property is damaged while they are legally on your premises, and you are found responsible for the accident.</p>
          </div>

          <mat-form-field appearance="outline" class="form-select">
            <mat-label class="form-select-placeholder-unselected">Limit to cover (KES)</mat-label>
            <input matInput formControlName="liability" inputmode="numeric">
          </mat-form-field>
        </div>
      </div>

      <div *ngIf="!canProceed" class="selection-error">
        <span *ngIf="!atLeastOneSelected">Please select at least one category to proceed.</span>
        <span *ngIf="atLeastOneSelected && !canProceed">Please select <strong>Building</strong>, or select <strong>Contents</strong> and enter a value for at least one of: <strong>House Furnishings</strong>, <strong>Kitchen Appliances</strong>, or <strong>Clothing</strong>.</span>
      </div>

      <div class="row-div margin-top-50">
        <button mat-stroked-button type="button" (click)="confirmCancel()">
          <span class="button-text">Cancel</span>
        </button>
        <button mat-button type="button" [disabled]="!canProceed" (click)="submitForm()">
          <span class="button-text">Save and Continue</span>
        </button>
      </div>
    </div>
  </form>
</div>
